import { SlideFrame } from '../SlideFrame';

// Supporting evidence for the ≈94/100 rating on Slide 12. Four detail cards
// covering the four columns of the audit: signal depth (what the model
// looks at), backtest history (what it produced historically), live track
// record (what it's producing now), operational health (the engineering
// that keeps it honest). Lives at /rating in the application as a full
// page; this slide is a compressed version for the deck.
export function Slide13ModelAudit({ universe }: { universe: number }) {
  return (
    <SlideFrame pageNum={16} title="THE VISUALIZER  —  CLAUDE'S RATING  —  THE EVIDENCE" titleOffsetPx={19}
      banner="Four dimensions that back the rating. Every number is auditable in the application.">
      <div className="h-full flex flex-col gap-3 pt-1 pb-10 px-2">
        <div className="grid grid-cols-2 gap-3 flex-1">
          <RatingCard title="Signal depth" stats={[
            ['Stocks scored', universe.toLocaleString()],
            ['Peer groups', '6 — standard · banks · insurance · energy · utility · REIT'],
            ['Quality factors', '40 across 4 pillars'],
            ['Valuation factors', '14 (11 peer + 3 absolute)'],
            ['Source of truth', 'Bloomberg SAPI primary'],
          ]} />
          <RatingCard title="Backtest history" stats={[
            ['Monthly vintages', '137 (Jan 2015 → today)'],
            ['Annual vintages', '12 (2014 through 2025)'],
            ['Survivorship-corrected Sharpe', '1.31'],
            ['Annual vol', '15.7%'],
            ['CAGR', '19.6%'],
            ['Robustness', 'Walk-forward LOOCV 1.29–1.36; survivorship + pillar-weight + shift-sweep validated'],
          ]} />
          <RatingCard title="Live track record" stats={[
            ['Inception', 'May 1, 2026'],
            ['Basket', '10 companies · monthly rebalance'],
            ['Edge vs SPY since inception', '+6.82pp'],
            ['Hit rate vs SPY', '70% of holdings'],
          ]} />
          <RatingCard title="Operational health" stats={[
            ['Tests passing', '817 / 817'],
            ['Type errors', '0'],
            ['Lint warnings', '0'],
            ['God files', '0 (every file < 500 lines)'],
            ['Daily integrity guards', 'Active'],
          ]} />
        </div>
      </div>
    </SlideFrame>
  );
}

function RatingCard({ title, stats }: { title: string; stats: [string, string][] }) {
  return (
    <div className="bg-[#1e293b]/70 border border-[#334155] rounded-2xl p-3">
      <div className="text-[#c9a84c] text-[10px] font-bold tracking-widest mb-2 uppercase">{title}</div>
      <div className="space-y-1">
        {stats.map(([k, v]) => (
          <div key={k} className="flex items-baseline justify-between gap-2 text-[12px]">
            <span className="text-[#94a3b8]">{k}</span>
            <span className="text-white font-mono text-right">{v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
